import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

/**
 * Renders a row of sponsor / partner logos.
 * Expects `logos` array like:
 *   [{ filename: "lwl.jpeg", alt: "LWL", url: "https://..." }, ...]
 * Files must live in `src/images/logos/`.
 */
export const SponsorLogos = ({ logos }) => {
  const [resolved, setResolved] = useState([]);

  useEffect(() => {
    if (!logos || logos.length === 0) {
      setResolved([]);
      return;
    }
    let cancelled = false;
    const load = async () => {
      const items = await Promise.all(
        logos.map(async (logo) => {
          try {
            const src = (await import(`../../images/logos/${logo.filename}`)).default;
            return { ...logo, src };
          } catch (e) {
            console.error(`Error loading logo "${logo.filename}":`, e);
            return null;
          }
        })
      );
      if (!cancelled) setResolved(items.filter(Boolean));
    };
    load().catch(e => console.log(e));
    return () => { cancelled = true; };
  }, [logos]);

  if (resolved.length === 0) return null;

  return (
    <Row className="d-flex align-items-center justify-content-center p-3 bg-white mt-5">
      {resolved.map((logo, index) => {
        const img = (
          <img
            src={logo.src}
            alt={logo.alt || ''}
            style={{ display: 'block', maxWidth: '100%', maxHeight: '120px', width: 'auto', margin: '0 auto' }}
          />
        );
        return (
          <Col
            key={index}
            xs={12}
            sm={6}
            md={4}
            lg={3}
            className="d-flex justify-content-center align-items-center pb-3"
          >
            {logo.url ? (
              <a href={logo.url} target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
                {img}
              </a>
            ) : img}
          </Col>
        );
      })}
    </Row>
  );
};

